import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const TERMS = [
  ["basis_price", "Basis Price"],
  ["taxes", "Taxes"],
  ["delivery", "Delivery"],
  ["way_bill", "Way Bill / Octroi"],
  ["order_payment", "Order & Payment"],
  ["extra", "Other Terms & Conditions"],
];

export const TermsSection = ({ terms, onChange, disabled }) => (
  <div className="grid sm:grid-cols-2 gap-3">
    {TERMS.map(([k, label]) => (
      <div key={k} className={k === "delivery" || k === "extra" ? "sm:col-span-2" : ""}>
        <Label className="text-xs">{label}</Label>
        <Textarea rows={k === "delivery" || k === "extra" ? 2 : 1} value={terms[k] || ""} disabled={disabled}
          onChange={(e) => onChange({ ...terms, [k]: e.target.value })} className="text-sm min-h-0 disabled:opacity-100 disabled:text-slate-800 disabled:bg-slate-50" data-testid={`quote-term-${k}`} />
      </div>
    ))}
  </div>
);
